module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/charles/Documents/AState-Senior/HCI/proj/amd2/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main